export const ru = {
  'ad.label': 'Реклама',
  'ad.sponsored_by': 'При поддержке {advertiser}',
  'ad.visit': 'Посетить',
  'cookies.preferences': 'Настройки файлов cookie',
  'cookies.title': 'Ваша конфиденциальность под вашим контролем',
  'cookies.description': 'Мы используем необходимое хранилище для работы Albambam. Аналитика и маркетинг включаются только с вашего разрешения. Вы можете отозвать его в любой момент. Ознакомьтесь с',
  'cookies.privacy_link': 'Политикой конфиденциальности',
  'cookies.close': 'Закрыть настройки',
  'cookies.necessary': 'Необходимые',
  'cookies.necessary_desc': 'Сессия, безопасность, язык и базовые настройки.',
  'cookies.analytics': 'Аналитика',
  'cookies.analytics_desc': 'Анонимное измерение использования для улучшения сервиса.',
  'cookies.marketing': 'Маркетинг',
  'cookies.marketing_desc': 'Персонализация рекламы и измерение кампаний.',
  'cookies.configure': 'Настроить',
  'cookies.reject': 'Отклонить необязательные',
  'cookies.save': 'Сохранить выбор',
  'cookies.accept': 'Принять все',
  'lang.selector_label': 'Язык',
  'lang.changed': 'Язык изменён',
  'nav.home': 'Главная',
  'nav.categories': 'Категории',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Друзья',
  'nav.upload': 'Загрузить',
  'nav.profile': 'Профиль',
  'nav.login': 'Войти',
  'common.signed_in': 'Вы вошли',
  'common.error': 'Ошибка',
  'topbar.search_placeholder': 'Поиск видео, авторов...',
  'legal.terms': 'Условия',
  'legal.privacy': 'Конфиденциальность',
  'nav.admin': 'Администрирование',
  'nav.logout': 'Выйти',
  'admin.tab.payments': 'Платежи',
  'admin.payments.title': 'Платежи',
  'cats.title': 'Категории',
  'cats.all': 'Все',
  'cats.adult_title': 'Категории 18+',
  'cats.empty': 'В этой категории нет видео.',
  'friends.block_confirm': 'Заблокировать этого друга? Вы больше не сможете общаться и видеть друг друга как друзья.',
  'friends.accepted': 'Теперь вы друзья!',
  'friends.title': 'Друзья',
  'friends.subtitle': 'Только те, кто взаимно подписан, становятся друзьями и могут общаться в личном чате.',
  'friends.unread_count_label': 'Непрочитанных сообщений: {n}',
  'friends.blocked_users_title': 'Заблокированные пользователи',
  'friends.unblock_user': 'Разблокировать',
  'friends.requests_title': 'Запросы на чат',
  'friends.request_badge': 'Запрос',
  'friends.request_accept': 'Принять',
  'friends.request_ignore': 'Игнорировать',
  'friends.empty_title': 'У вас пока нет друзей',
  'friends.empty_subtitle': 'Подпишитесь на кого-нибудь и дождитесь взаимной подписки, чтобы открыть личный чат.',
  'friends.attach_image': 'Фото',
  'friends.shared_video_label': 'Поделился видео',
  'friends.select_conversation': 'Выберите друга, чтобы начать общение',
  'friends.block_user': 'Заблокировать',
  'friends.no_messages_yet': 'Сообщений пока нет. Поздоровайтесь!',
  'friends.message_placeholder': 'Напишите сообщение...',
  'section.trending': 'В тренде',
  'section.shorts': 'Shorts',
  'section.for_you': 'Для вас',
  'home.hero.badge': 'Добро пожаловать в Albambam',
  'home.hero.title_1': 'Короткие видео.',
  'home.hero.title_2': 'Настоящие авторы.',
  'home.hero.subtitle': 'Смотрите, делитесь и зарабатывайте. Загружайте свои видео и открывайте новые таланты в каждой категории.',
  'home.hero.cta_shorts': 'Смотреть Shorts',
  'home.hero.cta_trending': 'В тренде',
  'home.shorts.see_all': 'Смотреть все',
  'home.empty.title': 'Видео пока нет',
  'home.empty.subtitle': 'Когда авторы загрузят контент, он появится здесь.',
  'live.send_diamonds': 'Отправить бриллианты',
  'live.buy': 'Купить',
  'live.chat': 'Чат',
  'live.type_message': 'Напишите сообщение...',
  'live.send': 'Отправить',
  'auth.success_google': 'Вход через Google выполнен',
  'auth.fail_google': 'Недействительная сессия Google',
  'auth.success_login': 'Вы вошли',
  'auth.success_register': 'Аккаунт создан',
  'auth.login_tab': 'Вход',
  'auth.register_tab': 'Создать аккаунт',
  'auth.email': 'Эл. почта',
  'auth.password': 'Пароль',
  'auth.submit_login_loading': 'Вход...',
  'auth.submit_login': 'Войти',
  'auth.name': 'Имя',
  'auth.submit_register_loading': 'Создание...',
  'auth.submit_register': 'Создать аккаунт',
  'auth.or': 'или',
  'legal.privacy_title': 'Политика конфиденциальности',
  'search.title': 'Результаты по запросу «{q}»',
  'search.count': 'Видео: {n}',
  'search.empty': 'Ничего не найдено.',
  'series.load_error': 'Не удалось загрузить сериал',
  'series.unlocked': 'Сериал разблокирован',
  'series.purchase_error': 'Не удалось начать покупку',
  'series.restricted': 'Доступ ограничен',
  'series.configure_access': 'Настроить доступ',
  'series.language_all': 'Все языки',
  'series.episode_count': 'Серий: {n}',
  'series.buy': 'Купить сериал',
  'series.filter_language': 'Фильтр по языку',
  'series.no_episodes': 'Опубликованных серий пока нет.',
  'series.episode_number': 'Серия {n}',
  'legal.terms_title': 'Условия использования',
  'lang.ca': 'Каталанский',
  'lang.en': 'Английский',
  'lang.es': 'Испанский',
  'lang.fr': 'Французский',
  'lang.de': 'Немецкий',
  'lang.it': 'Итальянский',
  'lang.eu': 'Баскский',
  'lang.gl': 'Галисийский',
  'lang.zh': 'Китайский',
  'lang.other': 'Другой',
  'lang.vi': 'Вьетнамский',
  'lang.ja': 'Японский',
  'lang.ko': 'Корейский',
  'lang.ru': 'Русский',
  'lang.ro': 'Румынский',
  'lang.ar': 'Арабский',
  'lang.tr': 'Турецкий',
  'lang.pl': 'Польский',
  'lang.ms': 'Малайский',
  'lang.ta': 'Тамильский',
  'upload.series_title_error': 'Введите название сериала',
  'upload.series_adult_category_error': 'Выберите категорию 18+ для сериала',
  'upload.series_created': 'Сериал создан',
  'upload.series_create_error': 'Не удалось создать сериал',
  'upload.err_file': 'Выберите корректный видеофайл',
  'upload.err_title': 'Укажите название',
  'upload.series_select_error': 'Выберите или создайте сериал',
  'upload.trailer_target_error': 'Выберите видео или сериал для трейлера',
  'upload.price_error': 'Введите корректную цену не менее 0,50 EUR.',
  'upload.adult_category_error': 'Выберите взрослую категорию',
  'upload.success': 'Видео успешно загружено',
  'upload.title_h': 'Загрузить видео',
  'upload.kind': 'Тип публикации',
  'upload.kind_video': 'Отдельное видео',
  'upload.kind_episode': 'Серия сериала',
  'upload.kind_trailer': 'Публичный трейлер в Shorts',
  'upload.series': 'Сериал',
  'upload.series_select': 'Выберите сериал',
  'upload.episode': 'Серия',
  'upload.series_new_title': 'Название нового сериала',
  'upload.series_create': 'Создать сериал',
  'upload.series_adult': 'Сериал 18+',
  'upload.series_premium': 'Премиум-сериал',
  'upload.series_adult_category': 'Категория 18+ сериала',
  'upload.series_price': 'Цена за серию и пакет (EUR)',
  'upload.trailer_for': 'Трейлер представляет',
  'upload.trailer_select': 'Выберите видео или сериал',
  'upload.video_prefix': 'Видео',
  'upload.file_label': 'Видеофайл (MP4, до 1ГБ)',
  'upload.file_pick': 'Нажмите, чтобы выбрать видео',
  'upload.thumb_label': 'Миниатюра (необязательно)',
  'upload.video_title': 'Название',
  'upload.description': 'Описание',
  'upload.category': 'Категория',
  'upload.is_short': 'Это Short (вертикальное)',
  'upload.paid_video': 'Платное видео',
  'upload.adult_content': 'Контент 18+',
  'upload.video_language': 'Язык видео',
  'upload.individual_price': 'Цена за просмотр этого видео (EUR)',
  'upload.paid_video_help': 'Зритель покупает постоянный доступ только к этому видео. Минимальная цена — 0,50 EUR.',
  'upload.adult_category': 'Взрослая категория',
  'upload.uploading': 'Загрузка {n}%',
  'upload.submit': 'Загрузить видео',
  'user.followers': 'подписчиков',
  'user.following': 'подписки',
  'user.follow': 'Подписаться',
  'user.chat_open': 'Чат',
  'user.request_sent': 'Запрос отправлен',
  'user.send_message': 'Отправить сообщение',
  'user.followers_title': 'Подписчики',
  'user.following_title': 'Подписки',
  'user.unfollow': 'Отписаться',
  'user.request_title': 'Запрос на чат',
  'user.request_subtitle': 'Вы можете отправить только одно сообщение. Если запрос примут, вы станете друзьями и сможете общаться.',
  'user.request_placeholder': 'Напишите ваше сообщение...',
  'user.request_send': 'Отправить запрос',
  'shorts.login_for_like': 'Войдите, чтобы поставить лайк',
  'watch.share_copied': 'Ссылка скопирована',
  'watch.delete_confirm': 'Удалить этот комментарий?',
  'ad.skip_in': 'Пропустить через {n}с',
  'ad.skip': 'Пропустить рекламу',
  'watch.share': 'Поделиться',
  'friends.share_video': 'Поделиться видео',
  'friends.send': 'Отправить',
  'watch.comments': 'Комментарии',
  'watch.write_comment': 'Напишите комментарий...',
  'watch.publish': 'Опубликовать',
  'watch.login_to_comment': 'Для комментариев нужно войти.',
  'watch.login_btn': 'Войдите, чтобы комментировать',
  'watch.no_comments': 'Комментариев пока нет.',
  'watch.related': 'Похожие',
  'nav.trending': 'В тренде',
  'friends.follow_option_only_follow': 'Подписаться',
  'friends.follow_option_friends': 'Друзья',
  'watch.like': 'Нравится',
  'watch.views_short': 'Просмотров: {n}',
  'shorts.empty.title': 'Shorts пока нет',
  'shorts.empty.subtitle': 'Загрузите короткое видео, чтобы открыть раздел.',
  'shorts.share': 'Поделиться',
  'auth.continue_google': 'Продолжить с Google',
  'upload.is_premium': 'Премиум',
  'upload.price': 'Цена (€)',
  'upload.err_select': 'Выберите видео',
  'profile.upload_btn': 'Загрузить видео',
  'profile.tab_videos': 'Мои видео ({n})',
  'profile.tab_history': 'История',
  'profile.tab_recos': 'Рекомендации',
  'profile.no_videos': 'Вы ещё не загрузили ни одного видео.',
  'profile.no_history': 'Вы ещё не смотрели видео.',
  'profile.no_recos': 'Посмотрите несколько видео, чтобы получать рекомендации.',
  'profile.likes': 'лайков',
  'profile.views': 'просмотров',
  'wallet.title': 'Кошелёк',
  'wallet.rate_label': 'Ставка',
  'wallet.min_label': 'Минимум для вывода',
  'wallet.amount_label': 'Сумма к выводу',
  'wallet.withdraw_btn': 'Запросить вывод',
  'wallet.history_title': 'История запросов',
  'wallet.success': 'Запрос создан',
  'wallet.bad_amount': 'Некорректная сумма',
  'wallet.per_view': '{rate} {cur}/просмотр',
  'admin.title': 'Администрирование',
  'admin.stats.users': 'Пользователи',
  'admin.stats.videos': 'Видео',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Просмотры',
  'admin.tab.videos': 'Видео',
  'admin.tab.ads': 'Реклама',
  'admin.tab.users': 'Пользователи',
  'admin.tab.withdrawals': 'Выводы',
  'admin.tab.config': 'Настройки',
  'admin.tab.translations': 'Языки',
  'tbl.title': 'Название',
  'tbl.creator': 'Автор',
  'tbl.category': 'Категория',
  'tbl.type': 'Тип',
  'tbl.views': 'Просмотры',
  'tbl.likes': 'Лайки',
  'tbl.status': 'Статус',
  'tbl.actions': 'Действия',
  'tbl.placement': 'Размещение',
  'tbl.advertiser': 'Рекламодатель',
  'tbl.impressions': 'Пок.',
  'tbl.clicks': 'Клики',
  'tbl.active': 'Активно',
  'tbl.name': 'Имя',
  'tbl.email': 'Почта',
  'tbl.role': 'Роль',
  'tbl.wallet': 'Кошелёк',
  'tbl.amount': 'Сумма',
  'tbl.date': 'Дата',
  'tbl.user': 'Пользователь',
  'video.video': 'Видео',
  'video.short': 'Short',
  'action.show': 'Опубликовать',
  'action.hide': 'Скрыть',
  'action.delete_confirm_video': 'Удалить видео?',
  'ad.create_h': 'Создать объявление',
  'ad.title_label': 'Название',
  'ad.image_label': 'URL изображения',
  'ad.target_label': 'Целевой URL',
  'ad.advertiser_label': 'Рекламодатель',
  'ad.placement_label': 'Размещение',
  'ad.placement.banner': 'Баннер (сайт)',
  'ad.placement.preroll': 'Пре-ролл (перед видео)',
  'ad.placement.overlay': 'Оверлей (в видео)',
  'ad.active': 'Активно',
  'ad.create_btn': 'Создать',
  'ad.success_create': 'Объявление создано',
  'ad.delete_confirm': 'Удалить объявление?',
  'users.make_admin': 'Сделать админом',
  'users.remove_admin': 'Убрать админа',
  'wd.approve': 'Одобрить',
  'wd.reject': 'Отклонить',
  'wd.mark_paid': 'Отметить оплаченным',
  'wd.empty': 'Запросов нет',
  'cfg.title': 'Настройки платежей',
  'cfg.rate_label': 'Оплата за просмотр ({cur})',
  'cfg.min_label': 'Минимум для вывода ({cur})',
  'cfg.currency': 'Валюта',
  'cfg.save': 'Сохранить',
  'cfg.saved': 'Настройки сохранены',
  'trans.title': 'Языки и переводы',
  'trans.intro': 'Загрузите JSON-файл с переводами для любого языкового кода (напр., ja, pt, zh). Файл должен содержать плоское сопоставление ключ → текст.',
  'trans.code_label': 'Код языка (напр., ja, pt-BR, zh)',
  'trans.name_label': 'Название (на этом языке)',
  'trans.file_label': 'JSON-файл переводов',
  'trans.upload': 'Загрузить',
  'trans.uploaded': 'Переводы сохранены',
  'trans.delete': 'Удалить',
  'trans.delete_confirm': 'Удалить этот язык?',
  'trans.builtin': 'Встроенный',
  'trans.custom': 'Пользовательский',
  'trans.empty_custom': 'Пользовательских языков пока нет.',
  'common.cancel': 'Отмена',
  'common.loading': 'Загрузка...',
  'common.too_fast': 'Слишком быстро, подождите немного',
  'time.few_seconds': 'несколько секунд назад',
  'time.min': '{n} мин назад',
  'time.h': '{n} ч назад',
  'time.d': '{n} дн назад',
  'time.w': '{n} нед назад',
  'time.mo': '{n} мес назад',
  'time.y': '{n} г назад',
  'brand.tagline': 'Короткие видео. Настоящие авторы.',
  'live.section': 'В эфире',
  'live.start': 'Начать эфир',
  'live.end': 'Завершить эфир',
  'live.join': 'Присоединиться к эфиру',
  'live.chat_placeholder': 'Напишите сообщение...',
  'live.diamond': 'Бриллиант',
  'live.buy_access': 'Купить доступ',
  'live.save_recording': 'Сохранить запись',
};
